import React from 'react'
import { Badge, Box, Label, Link } from '@alto-avios/alto-ui'
import { useTranslations } from 'next-intl'
import { PromotionalBannerData } from './PromotionalBanners.types'
import CollectAviosIcon from './CollectAviosIcon'
import styles from './PromotionalBannerItem.module.scss'

const TERMS_AND_CONDITIONS_PATH = '/terms-and-conditions'

interface PromotionalBannerItemProps extends PromotionalBannerData {
  single?: boolean
}

const PromotionalBannerItem = ({ text, tagLabel, single }: PromotionalBannerItemProps) => {
  const t = useTranslations('components.promotional_banners.labels')

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      gap="md"
      paddingX="lg"
      paddingY="md"
      width="full"
      backgroundColor="base"
      borderRadius="md"
      borderWidth="xs"
      borderStyle="solid"
      borderColour="secondary"
      dataTestId="promotional-banner-item"
    >
      <Box flexShrink={0}>
        <CollectAviosIcon />
      </Box>
      <section className={single ? styles.textAndBadgeSingle : styles.textAndBadge}>
        <Box flexGrow={1} flexShrink={1} minWidth="0">
          <Label as="span" size="sm" foregroundColor="primary">
            {text}{' '}
            <Link
              href={TERMS_AND_CONDITIONS_PATH}
              size="sm"
              underline
              iconEndProps={false}
              foregroundColor="primary"
            >
              {t('tcs_apply')}
            </Link>
          </Label>
        </Box>
        {tagLabel ? (
          <span className={styles.badge}>
            <Badge size="sm" styleVariant="neutral">
              {tagLabel}
            </Badge>
          </span>
        ) : null}
      </section>
    </Box>
  )
}

export default PromotionalBannerItem
